/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./action-button.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./action-button.component";
var styles_ActionButtonComponent = [i0.styles];
var RenderType_ActionButtonComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ActionButtonComponent, data: {} });
export { RenderType_ActionButtonComponent as RenderType_ActionButtonComponent };
export function View_ActionButtonComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "button-container"]], null, [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.action() !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null)), (_l()(), i1.ɵted(1, null, [" ", "\n"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.name; _ck(_v, 1, 0, currVal_0); }); }
export function View_ActionButtonComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "dev-action-button", [], null, null, null, View_ActionButtonComponent_0, RenderType_ActionButtonComponent)), i1.ɵdid(1, 49152, null, 0, i2.ActionButtonComponent, [], null, null)], null, null); }
var ActionButtonComponentNgFactory = i1.ɵccf("dev-action-button", i2.ActionButtonComponent, View_ActionButtonComponent_Host_0, { model: "model" }, {}, []);
export { ActionButtonComponentNgFactory as ActionButtonComponentNgFactory };
